import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.cuentasBancarias.detalle.editar.movimientos.servicio', {
    template: '<empleados-empleado-servicios-servicio id-empresa="idEmpresa" id-empleado="idEmpleado" id-moneda="idMoneda" on-close="cerrar()" folio="folio"/>',
    data: {title: '{{folio ? "Folio " + folio : "Agregar"}}'},
    url: '/:folio?',
    resolve: {
      folio: ($stateParams) => $stateParams['folio'],
    },
    controller ($scope, $state, folio, idEmpleado, idMoneda) {
      $scope.cerrar = cerrar
      $scope.folio = folio
      $scope.idEmpresa = '05'
      $scope.idEmpleado = idEmpleado
      $scope.idMoneda = idMoneda

      function cerrar () {
        $state.go('^.buscar')
      }
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/bancosCuentas/routes/cuentasBancarias/detalle/editar/movimientos/servicio.js